export const BUY_URL = 'https://ebookpoint.shop/cart/50005688189180:1'
export const SUPPORT_EMAIL = 'EbookDreamShop@gmail.com'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/7y19iqT9292BRnCxC7arff/ChatGPT_Image_Jul_15,_2026,_03_28_20_AM.png'

export const GYM_BG =
  'https://cdn.magicpatterns.com/patterns/generated-images/5a3312ed-82ee-469e-8557-1ef46188cacd.jpg'

export const PRICE = '21,99€'
export const OLD_PRICE = '40€'

export const TOTAL_CUPOS = 948

export interface ModuleItem {
  emoji: string
  title: string
  description: string
}

export const MODULES: ModuleItem[] = [
  {
    emoji: '🩹',
    title: 'Tomo 1 — Casos de lesión',
    description:
      'Consulta rápida para adaptar estaciones y guiar el retorno seguro de cada alumno.',
  },
  {
    emoji: '🩺',
    title: 'Tomo 2 — Evaluación e incorporación',
    description:
      'Evalúa el nivel, la movilidad y el historial antes de crear el plan de cada cliente.',
  },
  {
    emoji: '🔁',
    title: 'Tomo 3 — +60 variantes de rutinas A/B/C',
    description:
      'Rota sesiones de técnica, fuerza, resistencia y simulacro sin volver a improvisar.',
  },
  {
    emoji: '🎯',
    title: 'Tomo 4 — Corrección técnica y riesgos',
    description:
      'Detecta compensaciones, corrige a tiempo y sabe cuándo es mejor derivar.',
  },
  {
    emoji: '🏋️',
    title: 'Tomo 5 — Diseño de sesión',
    description:
      'Estructura clases claras de 45, 60 o 90 minutos para cualquier nivel de grupo.',
  },
  {
    emoji: '📊',
    title: 'Tomo 6 — Seguimiento multicliente',
    description:
      'Controla progresos y planificaciones de varios alumnos sin más carga administrativa.',
  },
  {
    emoji: '📈',
    title: 'Tomo 7 — Venta, retención y crecimiento',
    description:
      'Convierte mejores clases en más renovaciones, ventas y una oferta más rentable.',
  },
]

export interface BonusItem {
  emoji: string
  title: string
  description: string
  image: string
}

export const BONUSES: BonusItem[] = [
  {
    emoji: '📗',
    title: 'Bono 1 — Planificador multicliente (Excel)',
    description:
      'Versión ampliada del planificador de 12 semanas, con seguimiento simultáneo de varios alumnos en distintas fases de periodización y con diferentes fechas de competición.',
    image:
      'https://cdn.magicpatterns.com/uploads/wcbVL8jXQsUCkyGHDDPgCp/Bono1_Planificador_MultiCliente.png',
  },
  {
    emoji: '📋',
    title: 'Bono 2 — Lista de comprobación para evaluar a un nuevo alumno (PDF)',
    description:
      'Protocolo imprimible para la primera clase: preguntas sobre el historial, prueba física inicial y señales de alerta que detectar antes de programar.',
    image:
      'https://cdn.magicpatterns.com/uploads/czK9HV7Nb4eAtAnx24tzNr/Bono2_Checklist_Evaluacion.png',
  },
  {
    emoji: '🗒️',
    title:
      'Bono 3 — Plantillas de Sesión de 60 min (23 ejercicios y drills en 4 plantillas listas para usar)',
    description:
      'Colección de plantillas de clase listas para imprimir o utilizar en el gimnasio, organizadas por objetivo: técnica, fuerza, resistencia y simulacro.',
    image:
      'https://cdn.magicpatterns.com/uploads/6YcPCx5DzgBvLfN3qsCceR/Bono3_Plantillas_Sesion.png',
  },
  {
    emoji: '💬',
    title: 'Bono 4 — Guion de venta para cerrar planes mensuales (PDF)',
    description:
      'Guion paso a paso para la primera consulta o clase de prueba, con manejo de objeciones habituales («es caro», «no sé si voy a poder ir siempre», «ya entreno por mi cuenta»).',
    image:
      'https://cdn.magicpatterns.com/uploads/sxNWtiC6UnFtwy235hHQsL/Bono4_Guion_de_Venta.png',
  },
  {
    emoji: '🛡️',
    title: 'Bono 5 — Rutina de seguridad y responsabilidad del entrenador (PDF)',
    description:
      'Lista de comprobación de señales de riesgo que vigilar en una clase grupal y protocolo sobre cuándo y cómo derivar a un profesional sanitario, para protegerte a nivel legal y profesional.',
    image:
      'https://cdn.magicpatterns.com/uploads/6qNeVQd9SRGR1LSwNQQEYa/Bono5_Rutina_de_Seguridad.png',
  },
]

export const PROBLEMS: string[] = [
  'Programas la misma clase para todos y acabas sobrecargando a los principiantes mientras aburres a los avanzados.',
  'Sientes que improvisas cada semana y no tienes una estructura clara que puedas repetir sin perder variedad.',
  'Pierdes alumnos en temporada baja y no sabes cómo retenerlos cuando termina el calendario de competiciones.',
  'Ves compensaciones y fatiga peligrosa en clase, pero no sabes cuándo intervenir o cuándo derivar a un médico.',
  'Trabajas muchísimas horas, pero tu negocio no crece: no sabes cómo cerrar planes mensuales ni escalar tu oferta.',
]

export interface ShortTestimonial {
  name: string
  age: number
  city: string
  text: string
}

export const SHORT_TESTIMONIALS: ShortTestimonial[] = [
  {
    name: 'Rubén Álvarez',
    age: 34,
    city: 'Zaragoza',
    text: 'Como entrenador, me preocupaba la responsabilidad legal de las lesiones. La rutina de seguridad me dio la tranquilidad que necesitaba en cada clase.',
  },
  {
    name: 'Marta Iglesias',
    age: 29,
    city: 'Málaga',
    text: 'Pasé de perder alumnos en verano a retenerlos todo el año. La parte de temporada baja es justo lo que me faltaba.',
  },
  {
    name: 'David Torres',
    age: 41,
    city: 'Barcelona',
    text: 'Tengo un gimnasio pequeño con material limitado y aun así puedo dar clases de calidad. La gestión del tiempo y el espacio es genial.',
  },
  {
    name: 'Sergio Núñez',
    age: 37,
    city: 'A Coruña',
    text: 'Lo compré un martes por la noche y el miércoles ya estaba aplicando las plantillas de sesión. La entrega es inmediata de verdad.',
  },
]

export interface Objection {
  q: string
  a: string
}

export const OBJECTIONS: Objection[] = [
  {
    q: '«No tengo tiempo para leer los siete módulos completos»',
    a: 'No hace falta leerlo todo de golpe. Está organizado por módulos y puntos concretos para que vayas directamente a lo que necesitas hoy: si mañana tienes una clase con niveles mixtos, consulta el Módulo 3. Además, los bonos de Excel y las plantillas son de aplicación inmediata.',
  },
  {
    q: '«Llevo años entrenando, ¿me va a aportar algo?»',
    a: 'Si ya entrenas grupos, este sistema ordenará lo que ya haces y te dará la parte de negocio, venta y retención que casi ningún entrenador domina. La diferencia entre un buen entrenador y un negocio rentable está justo ahí.',
  },
  {
    q: '«¿Y si no es para mi tipo de gimnasio?»',
    a: 'El material está pensado para clases grupales, individuales e híbridas, con equipamiento limitado o completo. Las plantillas y variaciones se adaptan a tu contexto, no al revés.',
  },
  {
    q: '«21,99 € me parece una inversión importante»',
    a: 'Con cerrar un solo plan mensual nuevo usando los guiones de venta ya recuperas la inversión varias veces. Y hoy, además, te llevas los cinco bonos gratis. El precio normal es 62 €.',
  },
]

export const POPUP_NAMES = [
  'Javier',
  'Laura',
  'Carlos',
  'Nerea',
  'Rubén',
  'Marta',
  'David',
  'Sergio',
  'Ana',
  'Pablo',
  'Cristina',
  'Alejandro',
  'Lucía',
  'Miguel',
  'Sara',
  'Iker',
]

export const POPUP_CITIES = [
  'Madrid',
  'Barcelona',
  'Valencia',
  'Sevilla',
  'Bilbao',
  'Zaragoza',
  'Málaga',
  'Murcia',
  'Palma',
  'A Coruña',
  'Granada',
  'Vigo',
  'Gijón',
  'Vitoria',
  'Alicante',
]
